import { HourlyFootfallPrediction } from './HourlyFootfallPrediction';

/**
 * A class defines hourly footfall predictions for a specific date.
 */
export class DailyFootfallPrediction {
  date: string;
  hourlyPredictions: HourlyFootfallPrediction[];

  /**
   * @param date the date of footfall predictions.
   * @param hourlyPredictions footfall predictions for each hour.
   */
  constructor(date: string, hourlyPredictions: HourlyFootfallPrediction[]) {
    this.date = date;
    this.hourlyPredictions = hourlyPredictions;
  }

  /**
   * Finds the highest footfall prediction in a day.
   */
  findHighestFootfall(): number {
    return Math.max.apply(Math, this.hourlyPredictions.map(
      hourlyPrediction => hourlyPrediction.prediction)
    );
  }

  /**
   * Sums all footfall predictions of the day, and rounds them up.
   */
  sumAndRoundUpFootfall(): number {
    return this.hourlyPredictions
      .reduce((result, hourlyPrediction) => result + Math.ceil(hourlyPrediction.prediction), 0);
  }
}
